import styles from '../styles/app.module.css';

export function UnsupportedPage() {
  return (
    <div className={styles.error}>
      <h1>Your browser can&rsquo;t run the photobooth</h1>
      <p>
        We need WebGPU or WebGL2 to render the camera effects, and neither is
        available here.
      </p>
      <p style={{ color: 'var(--text-dim)' }}>
        Try the latest Chrome, Edge, Safari 17+, or Firefox 121+.
      </p>
    </div>
  );
}
